export class Chunk {
  id: number
  blob: Blob
  retriesAttempted = 0

  constructor(id: number, blob: Blob) {
    this.id = id
    this.blob = blob
  }

  get size() {
    return this.blob.size
  }

  get wasAlreadyRetried() {
    return this.retriesAttempted === 1
  }
}
